import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import  { EmergencyRequestCenterRoutingModule} from "./emergency-request-center-routing.module";

import { EmergencyRequestCenterComponent} from "./emergency-request-center.component";
import {CustomModule} from "../customs/custom.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule,
        EmergencyRequestCenterRoutingModule,
        CustomModule
    ],
    declarations: [EmergencyRequestCenterComponent]
})
export class EmergencyRequestCenterModule {}
